import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "923e29c4-3ba4-46f0-b6f1-6dc0658247d9",
    content: "The number of loudspeakers is variable for VBAP.",
    options: {},
  },
  {
    id: "6e9f78cb-71e8-4f5e-a271-768260a6ec1f",
    content: "At least three loudspeakers are required to cover left-right and up-down.",
    options: {},
  },
  { id: "4c721e03-a4ce-477c-b256-84ac454cec69", content: "VBAP is just working for one person.", options: {} },
];

export const task: Task = {
  id: "7b745dec-b1d2-4e00-a719-30cbb8209d82",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["6e9f78cb-71e8-4f5e-a271-768260a6ec1f"],
};
